import { useScaleFactor } from "./AHScaleFactor";

export function useDialogButtonHeight() {
  const sf = useScaleFactor();
  return 30 * sf;
}
